import { getLocalItem, setLocalItem } from "utils/localdb";

function getCookieName(lookup, type) {
  return `lastSeen_${type}_${lookup}`;
}

export function getLastSeenCookie({ lookup, type }) {
  getLocalItem(getCookieName(lookup, type));
}

export function setLastSeenCookie({ lookup, type }, value) {
  setLocalItem(getCookieName(lookup, type), value, {
    expires: 1,
  });
}
